import { motion, AnimatePresence } from 'motion/react';
import { X } from 'lucide-react';
import svgPaths from '../imports/svg-htpcs7ptn1';

interface IdentityValidationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartVerification?: () => void;
}

function IllustrationSeguranca() {
  return (
    <div className="relative" style={{ width: '135px', height: '196px' }}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 135 196">
        <g clipPath="url(#clip0_94_625)">
          <path d={svgPaths.p30c79780} fill="#833923" />
          <path d={svgPaths.p310d9200} fill="#FFBE99" />
          <path d={svgPaths.p1a2d8b40} fill="#FFBE99" />
          <path d={svgPaths.p883b500} fill="#E8A079" />
          <path d={svgPaths.p312f3b80} fill="#FFE000" />
          <path d={svgPaths.p7764100} fill="#E8A079" />
          <path d={svgPaths.p33436fc0} fill="#FFBE99" />
          <path d={svgPaths.p1fb06500} fill="white" />
          <path d={svgPaths.p13837a70} fill="#F0F2F5" stroke="#4994F0" strokeMiterlimit="10" strokeWidth="0.751669" />
          <path d={svgPaths.p966bb00} stroke="#4994F0" strokeMiterlimit="10" strokeWidth="0.751669" />
          <path d={svgPaths.p162d5900} stroke="#4994F0" strokeMiterlimit="10" strokeWidth="0.751669" />
          <path d={svgPaths.p14ecb9f2} stroke="#4994F0" strokeMiterlimit="10" strokeWidth="0.751669" />
          <g>
            <path d={svgPaths.p3b44a100} fill="#833923" />
            <path d={svgPaths.p1f17fb00} fill="#FF9C83" />
            <path d={svgPaths.p31cc4300} fill="#EA6748" />
            <path d={svgPaths.p3acbff80} fill="#FF9C83" />
            <path d={svgPaths.p218de930} fill="#1D1D1B" />
            <path d={svgPaths.p1b44a700} fill="#1D1D1B" />
            <path d={svgPaths.p21d02478} fill="#EA6748" />
            <path d={svgPaths.pbd90e00} fill="#EA6748" />
            <path d={svgPaths.p395fb180} fill="white" />
            <path d={svgPaths.p2a83c900} fill="#FFE000" />
            <path d={svgPaths.p20ccb500} fill="#833923" />
            <path d={svgPaths.p296f5b00} fill="#833923" />
          </g>
          <path d={svgPaths.p18a62bb0} stroke="#4994F0" strokeMiterlimit="10" strokeWidth="0.751669" />
          <path d={svgPaths.p1fae100} stroke="#4994F0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.751669" />
          <path d="M29.6693 33.1951V66.9355" stroke="#4994F0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.751669" />
          <path d={svgPaths.p2582b740} stroke="#4994F0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.751669" />
          <path d={svgPaths.p89f370} stroke="#4994F0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.751669" />
          <path d={svgPaths.p349d00} fill="#BE533E" />
          <path d={svgPaths.pb3c2900} fill="#FFBE99" />
          <path d={svgPaths.p2ee87680} fill="#E8A079" />
          <path d={svgPaths.p2d605500} fill="#E8A079" />
          <path d={svgPaths.p1d461980} fill="#E8A079" />
          <path d={svgPaths.p3cd12f00} fill="#E8A079" />
          <path d={svgPaths.p19c25e00} fill="#E8A079" />
          <path d={svgPaths.p4f1c800} stroke="white" strokeMiterlimit="10" strokeWidth="0.375835" />
          <path d={svgPaths.p26848200} stroke="white" strokeMiterlimit="10" strokeWidth="0.375835" />
          <path d={svgPaths.p25aaf080} stroke="white" strokeMiterlimit="10" strokeWidth="0.375835" />
          <path d={svgPaths.p27389080} fill="#1D1D1B" />
          <path d={svgPaths.p1738d600} fill="#1D1D1B" />
          <path d={svgPaths.p23a5fc0} fill="#E8A079" />
          <path d={svgPaths.p160f6c80} fill="#833923" />
          <path d={svgPaths.pfed9410} fill="#833923" />
          <path d={svgPaths.p34f8ec00} fill="#1D1D1B" />
          <path d={svgPaths.p1b9e4b00} fill="#1D1D1B" />
          <path d={svgPaths.p3deae300} fill="#BE533E" />
          <path d={svgPaths.p25a17600} fill="#FFBE99" />
          <path d={svgPaths.p344259f0} fill="#EA6748" />
          <path d={svgPaths.p2bd8f500} fill="#EA6748" />
          <path d={svgPaths.pd1e9500} fill="#E8A079" />
        </g>
        <defs>
          <clipPath id="clip0_94_625">
            <rect fill="white" height="195.845" width="135.001" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export function IdentityValidationModal({
  isOpen,
  onClose,
  onStartVerification,
}: IdentityValidationModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            style={{ backdropFilter: 'blur(4px)' }}
          />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <motion.div
              className="relative w-full max-w-md overflow-hidden"
              style={{
                backgroundColor: 'var(--background)',
                borderRadius: 'var(--radius-card)',
                boxShadow: 'var(--elevation-lg)',
              }}
              initial={{ opacity: 0, scale: 0.95, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 20 }}
              transition={{ duration: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {/* Header */}
              <div className="flex items-center justify-between p-5 border-b" style={{ borderColor: 'var(--border)' }}>
                <h3
                  style={{
                    fontSize: 'var(--text-lg)',
                    fontWeight: 'var(--font-weight-semibold)',
                    color: 'var(--foreground)',
                    lineHeight: '1.4',
                  }}
                >
                  Valide sua identidade
                </h3>
                <button
                  onClick={onClose}
                  className="flex items-center justify-center transition-colors"
                  style={{
                    width: '32px',
                    height: '32px',
                    color: 'var(--muted-foreground)',
                  }}
                  aria-label="Fechar"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col items-center">
                {/* Illustration */}
                <div className="mb-6">
                  <IllustrationSeguranca />
                </div>

                {/* Text content */}
                <p
                  className="text-center mb-5"
                  style={{
                    fontSize: 'var(--text-base)',
                    fontWeight: 'var(--font-weight-normal)',
                    color: 'var(--muted-foreground)',
                    lineHeight: '1.6',
                  }}
                >
                  Antes de liberar pedidos, você precisa fazer a verificação facial.
                </p>

                {/* Info Box */}
                <div
                  className="p-4 mb-6 w-full"
                  style={{
                    backgroundColor: 'var(--kojo-blue-subtle)',
                    borderRadius: 'var(--radius-button)',
                    border: '1px solid var(--kojo-blue-light)',
                  }}
                >
                  <p
                    style={{
                      fontSize: 'var(--text-sm)',
                      fontWeight: 'var(--font-weight-normal)',
                      color: '#1e3a8a',
                      lineHeight: '1.5',
                    }}
                  >
                    A verificação é rápida e segura. Vamos usar sua câmera para confirmar sua identidade.
                  </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col gap-3 w-full">
                  <motion.button
                    onClick={onStartVerification}
                    className="w-full px-5 py-3 transition-all"
                    style={{
                      backgroundColor: 'var(--kojo-blue)',
                      color: 'var(--primary-foreground)',
                      fontSize: 'var(--text-base)',
                      fontWeight: 'var(--font-weight-semibold)',
                      borderRadius: 'var(--radius-button)',
                      border: 'none',
                    }}
                    whileHover={{ backgroundColor: 'var(--kojo-blue-dark)' }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Começar verificação
                  </motion.button>

                  <motion.button
                    onClick={onClose}
                    className="w-full px-5 py-3 transition-all"
                    style={{
                      backgroundColor: 'var(--background)',
                      color: 'var(--foreground)',
                      fontSize: 'var(--text-base)',
                      fontWeight: 'var(--font-weight-medium)',
                      borderRadius: 'var(--radius-button)',
                      border: '1px solid var(--border)',
                    }}
                    whileHover={{ backgroundColor: 'var(--neutral-50)' }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Fechar
                  </motion.button>
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
}